<template>
  <v-layout row wrap class="pt-4">
    <v-flex xs12>
      <v-data-table
        disable-initial-sort
        :headers="headers"
        :items="reportData"
        :pagination.sync="pagination"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.employee_name }}</td>
          <td class="text-xs-left">{{ props.item.action_datetime | date('YYYY-MM-DD') }}</td>
          <td class="text-xs-left">{{ props.item.action_datetime | date('HH:mm:ss') }}</td>
          <td class="text-xs-left">{{ props.item.action_datetime | date('YYYY-MM-DD HH:mm:ss') }}</td>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    data() {
      return {
        reportData: [],
        pagination: { rowsPerPage: -1 },
        headers: [
          {text: 'Ф.И.О сотрудника', align: 'left', value: 'employee_name'},
          {text: 'День', align: 'left', value: 'action_datetime'},
          {text: 'Время', align: 'left', value: 'action_datetime'},
          {text: 'Полная дата', align: 'left', value: 'action_datetime'}
        ]
      }
    },
    created() {
      this.reportData = this.$store.getters.reportData
    },
    mounted() {
      window.print()
      window.history.back()
    }
  }
</script>
